import { useStore } from "@tanstack/react-store";
import { ChangePasswordModal } from "@/components/common/modals/change-password-modal";
import { ConfirmFinishModal } from "@/components/common/modals/confirm-finish-modal";
import { LeaveTabWarningModal } from "@/components/common/modals/leave-tab-warning-modal";
import { OrientationsModal } from "@/components/common/modals/orientations-modal";
import { RedoModal } from "@/components/common/modals/redo-modal";
import { ReportQuestionErrorModal } from "@/components/common/modals/report-question-error-modal";
import { SubjectPerformanceModal } from "@/components/common/modals/subject-performance-modal";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { closeModal, modalStore } from "@/store/modal.store";

export const modals = {
	ExemploModal: () => <DialogContent>Exemplo Modal</DialogContent>,
	OrientationsModal,
	RedoModal,
	ConfirmFinishModal,
	LeaveTabWarningModal,
	ReportQuestionErrorModal,
	SubjectPerformanceModal,
	ChangePasswordModal,
} as const;

export type ModalDataMap = {
	[K in keyof typeof modals]: React.ComponentProps<(typeof modals)[K]>;
};

export type TModalKeys = keyof typeof modals;

export function ModalRoot() {
	const modalState = useStore(modalStore, (state) => state);

	const ModalComponent = modalState.modalKey
		? (modals[modalState.modalKey] as React.ComponentType<
				Record<string, unknown>
			>)
		: null;

	return (
		<Dialog
			open={modalState.isOpen}
			onOpenChange={(open) => !open && closeModal()}
		>
			{ModalComponent && (
				<ModalComponent
					{...(modalState.data as React.ComponentProps<typeof ModalComponent>)}
				/>
			)}
		</Dialog>
	);
}
